<template>
  <el-dialog :title="form.id?'编辑福利':'新建福利'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="福利类型名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入福利类型名称" />
      </el-form-item>
      <el-form-item label="背景图片" prop="bgImage">
        <imageUpload v-model="form.bgImage" width="50" height="50" />
      </el-form-item>
      <el-form-item label="会议类型" prop="meetingCategoryId" v-if="!form.id || form.id > 1">
        <el-select v-model="form.meetingCategoryId" filterable clearable placeholder="请选择会议类型">
          <el-option v-for="item in meetingCategoryOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参加条件" prop="joinCondition" v-if="!form.id || form.id > 1">
        <el-radio-group v-model="form.joinCondition">
          <el-radio :label="1">报名</el-radio>
          <el-radio :label="2">签到</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="页面排序">
        <el-input v-model="form.orderNo" placeholder="请输入页面排序" />
        <!-- <span>系统自动带出排序，并支持修改</span> -->
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>{{form.state?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import courseWelfareClassificationApi from '@/api/course/courseWelfareClassification'
import meetingCategoryApi from '@/api/meeting/meetingCategory'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    name: null,
    meetingCategoryId: null,
    joinCondition: null,
    orderNo: null,
    bgImage: null,
    state: 0,
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入福利类型名称', trigger: 'blur' }],
        bgImage: [{ required: true, message: '请上传背景图片', trigger: 'change' }],
        meetingCategoryId: [{ required: true, message: '请选择会议类型', trigger: 'change' }],
        joinCondition: [{ required: true, message: '请选择参加条件', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
      meetingCategoryOptions: []
    }
  },
  created() {
    meetingCategoryApi.fetchList({ pageNo: 1, pageSize: 100, isEnable: true }).then(({data}) => { this.meetingCategoryOptions = data.list })
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      row.meetingCategoryId = +row.meetingCategoryId
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.orderNo = params.orderNo || 0

      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseWelfareClassificationApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseWelfareClassificationApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
